import { AGREEMENT_SHEET_COLUMNS, type AgreementDataRow } from '../models/agreement-sheet.model';
import type { TabularSheetCellValue } from '../../shared/tabular-sheet-payload.model';

/** Projects {@link AgreementDataRow} into Excel cell values in {@link AGREEMENT_SHEET_COLUMNS} order. */
export function agreementDataRowToCellValues(
    row: AgreementDataRow
): readonly TabularSheetCellValue[] {
    return AGREEMENT_SHEET_COLUMNS.map((col) => row[col.key]);
}
